import React from "react";
import { Container, NumberArea, IconArea } from "./Styled";
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';

type IndicatorProps = {
    isIncrease: boolean;
    text: string;
};

export const Indicator = ({
    isIncrease,
    text
}: IndicatorProps) => {
    const color = isIncrease ? "green" : "red";
    return (
        <Container color={color}>
            <IconArea>
                {isIncrease ? <CaretUpOutlined style={{ color: color }}/> : <CaretDownOutlined style={{ color: color }}/>}
            </IconArea>
            <NumberArea>{text}</NumberArea>
        </Container>
    );
};

export default Indicator;